import { useScreenSize } from '@mchs/web-core';
import { ReactNode } from 'react';
import { ResponsiveSizeUtility } from '../../../../../../../utils';
import { StackedRow } from '../../../../../../../core';

interface ColumnsProps {
  children: ReactNode;
}

const Columns: React.FC<ColumnsProps> = (props: ColumnsProps) => {
  const screenSize = useScreenSize();

  const narrowWidth = ResponsiveSizeUtility.isNarrowWidth(screenSize.width);
  narrowWidth;
  props;

  return (
    <>
      {narrowWidth ? (
        <>{props.children}</>
      ) : (
        <StackedRow>{props.children}</StackedRow>
      )}
    </>
  );
};

export default Columns;
